<template>
    <section class="app-main">
        <!-- <breadcrumb id="breadcrumb-container" /> -->
        <!-- <transition name="fade-transform" mode="out-in"> -->
            <keep-alive :include="cachedViews">
                <router-view :key="key" />
            </keep-alive>
        <!-- </transition> -->
    </section>
</template>

<script>
// import Breadcrumb from "@/components/TtaBreadcrumb";
export default {
    name: "AppMain",
    components: {
        // Breadcrumb,
    },
    computed: {
        cachedViews() {
            return this.$store.state.tagsView.cachedViews;
        },
        key() {
            return this.$route.path;
        },
    },
};
</script>

<style lang="scss" scoped>
.app-main {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow: auto;
    position: relative;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
/* .el-popup-parent--hidden {
    .fixed-header {
        padding-right: 15px;
    }
} */
</style>
